<template>
  <div>
    <div class="colspan" id="donationRC">
      <div class="top clearfix">
        <p class="p1 clearfix">
          <i class="el-icon-s-order"></i>
          {{title}}
        </p>
      </div>
       <div id="searchForm">
        <el-form :model="search" ref="ruleForm"  class="demo-ruleForm" inline>
          <el-form-item >
            <el-input v-model="search.pub_name" placeholder="捐赠人" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-input v-model="search.org_name" placeholder="单位名称" clearable></el-input>
          </el-form-item>
          <el-form-item class="marginRight0">
            <el-date-picker type="date" placeholder="捐赠时间起" v-model="search.created_at_min" 
            style="width: 100%;"  :picker-options="pickerOptionsStart" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <span class="middleLine">-</span>
          <el-form-item >
            <el-date-picker type="date" placeholder="捐赠时间止" v-model="search.created_at_max" 
            style="width: 100%;" :picker-options="pickerOptionsEnd" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item id="lastItem">
            <el-button type="primary" @click="submitForm('ruleForm')" >搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="content">
        <div class="title">
          <div>项目名称</div>
          <div>捐款人单位</div>
          <div>捐款人姓名</div>
          <div>捐款金额</div>
          <div>捐赠时间</div>
        </div>
        <ul>
          <li v-for="item in infoList" :key="'aa'+item.id" @click="goto(item.project_id)">
            <div :title="item.project_name">{{item.project_name}}</div>
            <div :title="item.org_name?item.org_name:'个人'">
              <div>{{item.org_name?item.org_name:'个人'}}</div>
            </div>
            <div :title="item.pub_name||item.name">
              <div>{{item.pub_name||item.name}}</div>
            </div>
            <div>
              <div>￥{{item.money}}</div>
            </div>
            <div>{{item.created_at}}</div>
          </li>
        </ul>
        <div v-if="infoList.length==0" class="nullData">
          暂无数据
        </div>
      </div>
      
      <div class="page" v-if="infoList.length>0">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="total"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import merge from "webpack-merge";
export default {
  data() {
    let self =this;
    return {
      infoList: [],
      title: "",
      page: 1,
      page_size: 10,
      total: 0,
      cate_id: null,
      id: null, //导航id
      // cate_id: [] ,//分类ID
      second_navId: null, //二级导航
      search:{
        pub_name:'',
        org_name:'',
        created_at_max:'',
        created_at_min:''
      },
      pickerOptionsStart: {
        disabledDate(time) {
          if(self.search.created_at_max){
            return time.getTime() > new Date(self.search.created_at_max);
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate(time) {
          if(self.search.created_at_min){
            return time.getTime() < new Date(self.search.created_at_min) - 8.64e7;
          }
        }
      }
    };
  },
  methods: {
    goto(id) {
      this.$router.push({
        name: "pubProjectDetail",
        query: { projectInfoId: id }
      });
    },
    prev() {},

    //点击下一页和点击页码时执行
    handleCurrentChange(val) {
      this.pageSync(val);
      this.getPageData();
    },

    getPageData() {
      let that = this;
      let params = {};
      params.page_size = this.page_size;
      params.page = this.page;
      if(this.search){
        let searchObj = this.search;
        for(var i in searchObj) {
          if(searchObj[i]){
            params[i] = searchObj[i];
          }
        } 
      }
      for(var i in params) {
        if(!params[i] || params[i]==""){
          delete params[i]
        }
      } 
      this.$db
        .get(
          this.$url.donation.list,params)
        .then(res => {
          that.infoList = res.data.data;
          that.total = res.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    pageSync(val){
      let query =this.$route.query;
       this.$router.push({
          query:merge(this.$route.query,{'page':val})
      });
    },
    submitForm(formName) {
      this.getPageData();
    },
  },
  created() {
    this.id = this.$route.query.id;
    let that = this;
    if(this.$route.query.page){
      this.page = Number(this.$route.query.page);
    }
    else{
      this.page=1;
      this.pageSync(1);
    }
    this.getPageData();
    that.$db
      .get(this.$url.channel.url + "/" + this.id)
      .then(res => {
        that.title = res.data.title;
      })
      .catch(err => {
        console.log(err);
      });
  },
  watch: {
    "$route.query.id": function(value) {
      if (value) {
        this.id = value;
        this.page = 1;
        this.getPageData();
      }
    },
    "$route.query.second_navId": function(value) {
      if (value) {
        this.second_navId = value;
        this.page = 1;
        this.getPageData();
      } else if (typeof value == "undefined") {
        // this.getPageData(this.id);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.colspan {
  // float: left;
  width: 950px;
  // min-height: 500px;
  overflow: hidden;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
  box-sizing: border-box;
  > .top {
    > .p1 {
      margin: 0;
      float: left;
      margin-left: 12px;
      font-size: 20px;
      height: 26px;
      border-top: 2px solid #fff;
      padding-top: 20px;
    }
  }
  > .content {
    min-height: 500px;
    .title {
      margin: 16px 30px 0;
      box-sizing: border-box;
      height: 49px;
      line-height: 50px;
      color: #404040;
      border-bottom: 1px dashed #ccc;
      > div {
        float: left;
      }
      > div:nth-of-type(1) {
        width: 25%;
      }
      > div:nth-of-type(2) {
        width: 25%;
      }
      > div:nth-of-type(3) {
        width: 17%;
      }
      > div:nth-of-type(4) {
        width: 13%;
      }
      > div:nth-of-type(5) {
        width: 20%;
      }
    }
    > ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      > li {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px dashed #ccc;
        color: #404040;
        font-size: 14px;
        margin: 0 30px;
        box-sizing: border-box;
        cursor: pointer;
        > div {
          float: left;
          margin: 0;
          width: 25%;
          font-size: 16px;
          color: #404040;
          overflow: hidden;
          text-overflow: ellipsis; //超出部分以省略号显示
          white-space: nowrap;
        }
        > div:nth-of-type(1) {
          width: 25%;
        }
        > div:nth-of-type(2) {
          width: 25%;
          > div {
            padding-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis; //超出部分以省略号显示
            white-space: nowrap;
          }
        }
        > div:nth-of-type(3) {
          width: 17%;
          > div {
            padding-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis; //超出部分以省略号显示
            white-space: nowrap;
          }
        }
        > div:nth-of-type(4) {
          width: 13%;
          > div {
            padding-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis; //超出部分以省略号显示
            white-space: nowrap;
          }
        }
        > div:nth-of-type(5) {
          color: #888;
          width: 20%;
        }
      }
      > li:nth-last-child(1) {
        border-bottom: none;
      }
    }
  }
  > .page {
    // position: absolute;
    // left: 50%;
    // bottom: 50px;
    float: left;
    overflow: hidden;
    margin-left: 50%;
    margin-top: 20px;
    height: 100px;
    line-height: 100px;
    transform: translateX(-50%);
  }
  .page /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    color: #fff;
  }
  .page /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ea373b;
  }
  .page /deep/ .el-pagination.is-background .el-pager li:hover {
    color: #ea373b;
  }
}
#searchForm {
  margin-top:20px;
  padding-left:30px;
  height: 40px;
  .el-form--inline /deep/  .el-form-item{
    width:145px !important;    
  }
  .el-form--inline /deep/  #lastItem{
    width:70px !important;
    button{
     border-radius: 4px;
    }
  }
  .el-form /deep/.el-input__inner{
    height:30px !important;
    line-height: 30px !important;
  }
  .el-form /deep/.el-button{
     padding: 6px 15px;
     border-radius: 0px;
  }
  .middleLine{
    line-height: 35px;
  }
  .el-form--inline /deep/ .marginRight0{
    margin-right: 0px !important;
  }
}
.nullData{
  text-align: center;
  margin-top:20px;
  color:#666;
}
</style>


// WEBPACK FOOTER //
// src/components/donation/rightContent.vue